import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import DrawingSearchPanel from "../DesignerSearchPanel";
import DrawingSnGrid from "../DesignerSnGrid";

interface Props {
  loadData?: any;
}

const TemplateReg1 = forwardRef(({ loadData }: Props, ref) => {
  const gridRef = useRef<any>(null);
  const searchRef = useRef<any>(null);
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColumns] = useState<any[]>([{}]);
  const [gridSettings, setGridSettings] = useState<any[]>([{}]);

  useEffect(() => {
    if (!loadData) {
      setFormData(null);
      setFormControlData([]);
      setColumns([{}]);
    } else {
      setFormData(loadData.formData);
      setFormControlData(loadData.formControlData);
      setColumns(loadData.grid.grid1);
      if (loadData.gridSettings?.grid1)
        setGridSettings(loadData.gridSettings.grid1);
    }
  }, [loadData]);

  useImperativeHandle(ref, () => ({
    getSaveData,
  }));

  const getSaveData = async () => {
    const searchformData = await searchRef.current.getFormData();
    const searchControls = await searchRef.current.getControls();
    const gridColumns = await gridRef.current.getColumns();
    const gridSettings = await gridRef.current.getSettings();
    const columnsInfo: any[] = gridSettings.columnsInfo;

    let newDefaultValue: any = {};
    columnsInfo.map((col) => {
      if (searchformData[col.column_name] !== undefined) {
        newDefaultValue[col.column_name] = `searchInfo.${col.column_name}`;
      }
    });

    const rtn = {
      formData: searchformData,
      formControlData: searchControls,
      grid: { grid1: gridColumns },
      gridSettings: {
        grid1: {
          ...gridSettings,
          defaultValue: { ...gridSettings.defaultValue, ...newDefaultValue },
        },
      },
    };
    return rtn;
  };

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <DrawingSearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></DrawingSearchPanel>
      </div>
      <div className="flex-1">
        <DrawingSnGrid
          ref={gridRef}
          seq={1}
          enableAddRow={true}
          columnConfig={columns}
          rowData={[]}
          title="타이틀"
          settingsData={gridSettings}
        />
      </div>
    </div>
  );
});

export default TemplateReg1;
